import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-common-input',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './common-input.component.html',
  styleUrl: './common-input.component.scss',
})
export class CommonInputComponent implements OnInit {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() isSubmit: boolean = false;
  inputId = 'inputFieldId_' + Math.random().toString(36).substring(7);
  @Input() inputType: 'text' | 'password' = 'text';
  @Input() isRequired: boolean = false;
  @Input() maxLength: number = 100;

  value: any;
  @Input() isDisabled: boolean = false;
  onChange = (_: any) => {};
  onTouched = () => {};
  isPasswordVisible: boolean = false;

  @Input() showSearchIcon: boolean = false;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.inputType === 'password') {
      this.type = 'password';
    }
  }

  get formControl() {
    return this.ngControl?.control;
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInputChange(event: any) {
    let inputValue = event.target.value ?? '';
    const trimmedValue = inputValue.trimStart();

    event.target.value = trimmedValue;

    if (
      trimmedValue.length > this.maxLength &&
      trimmedValue.length >= (this.value?.length || 0)
    ) {
      event.target.value = this.value ?? '';
      return;
    }

    // Do not trigger form update if trimmed value is same as current value
    if (trimmedValue === (this.value ?? '')) {
      return;
    }

    this.value = trimmedValue;
    this.onChange(this.value);
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  hasValidator(
    control: AbstractControl | null,
    validator: ValidatorFn,
  ): boolean {
    if (control && control.validator) {
      const controlValidator = control.validator({} as AbstractControl);
      if (controlValidator && controlValidator.hasOwnProperty(validator.name)) {
        return true;
      }
    }
    return false;
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.togglePasswordVisibility();
    }
  }
}
